import React from 'react';
import { useTranslation } from 'react-i18next';
import { WeezHeader, Button, Icon } from '@weezevent/nacre';
import WidgetList from '../../widgetList';
import WidgetCreationModal from '../../components/widget_creation_modal/modal';

export default function OnlineTicketingList({ organization }) {
    const { t } = useTranslation();
    const [openCreationModal, setOpenCreationModal] = React.useState(false);

    return (
        <>
            {openCreationModal && <WidgetCreationModal open={openCreationModal} organization={organization} onClose={() => setOpenCreationModal(false)} />}
            <WeezHeader
                title={t('ticket.online_ticketing.list.title')}
                rightComponent={[
                    <Button key={0} onClick={() => setOpenCreationModal(true)} primary icon={<Icon name="plus" />}>
                        {t('ticket.online_ticketing.list.create_new')}
                    </Button>
                ]}
            >
                {t('ticket.online_ticketing.list.description')}
            </WeezHeader>
            <WidgetList onlyWidgetEngine usages={['sale', 'resale', 'multi_events']} context="online_ticketing" organizationId={organization.id} />
        </>
    );
}
